import Table from '../../../../components/common/table/Table'
import { ColumnsType } from 'antd/lib/table'
import ClockIcon from 'src/assets/icons/clock.svg?react'
import Timeline from '../skillTimeline/SkillTimeline'
import { SkillsTableDataType } from 'src/types/expert.types'
import React, { useMemo } from 'react'
import { EmptyTableText } from 'src/constants/experts.constants'
import { DataTestId } from 'src/constants/ui.constants'

export const SkillsTableColumns: ColumnsType<SkillsTableDataType> = [
    {
        title: 'Skill',
        dataIndex: 'skill',
        key: 'skill',
        width: 200,
    },
    {
        title: 'Level',
        dataIndex: 'level',
        key: 'level',
        width: 100,
    },
    {
        title: 'Score',
        dataIndex: 'score',
        key: 'score',
        width: 50,
    },
    {
        title: 'Skill validated by',
        dataIndex: 'skillValidatedBy',
        key: 'skillValidatedBy',
        width: 120,
    },
    {
        title: 'Validation log',
        dataIndex: 'validationLog',
        key: 'validationLog',
        width: 75,
        align: 'center',
    },
]

export type SkillsTableProps = {
    dataSource: SkillsTableDataType[]
    isLoading: boolean
}

const SkillsTable: React.FC<SkillsTableProps> = props => {
    const columns = useMemo(() => {
        return [...SkillsTableColumns].map(column => {
            if (column.key === 'validationLog') {
                return {
                    ...column,
                    render: (validationLog: SkillsTableDataType['validationLog']) => {
                        return (
                            <Timeline skillValidations={validationLog}>
                                <ClockIcon />
                            </Timeline>
                        )
                    },
                }
            }
            return column
        })
    }, [])

    return (
        <div className={'skills-table-override'} data-testid={DataTestId.SkillsTable}>
            <Table
                columns={columns}
                dataSource={props.dataSource}
                pagination={false}
                scroll={{ y: '250px' }}
                loading={props.isLoading}
                emptyIconText={EmptyTableText.NoSkillsFound}
                emptyTableHeight={'200px'}
            />
        </div>
    )
}

export default SkillsTable
